export const FILTER_TYPES = {
  LOCATION: 'location',
  COUNTRY: 'country',
  MARKET: 'market',
  REGION: 'region',
  SEARCH_VALUE: 'q',
  DAYS_COUNT_START: 'daysCountStart',
  DAYS_COUNT_END: 'daysCountEnd',
  TOUR: 'tour',
  DURATION: 'duration',
};

export const ID_TYPES = {
  location: 'location_id',
  country: 'country_id',
  market: 'market_id',
  region: 'region_id',
};

export const DURATION_VALUE = {
  ANY: 'any',
  FROM_TWO_TO_FIVE: '2-5',
  FROM_SIX_TO_TEN: '6-10',
  UP_ELEVEN: '11+',
};
